import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import dayjs from 'dayjs';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getProductCategoriesDropdown } from 'actions/EntityActions';
import { getCsvReport, getInventoryAtDateGuid, getSageExportGuid } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import reportsUtil from 'utils/reportsApi';
import Grid from 'screens/components/basic/Grid';
import PageHeader from 'screens/components/basic/PageHeader';
import { reportHightideReportsCrumb } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import { showError, showLoadingSpinner, hideLoadingSpinner } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';

class HightideReports extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };

    }

    componentWillMount() {
        const date = dayjs().format('YYYY-MM-DDTHH:mm:ss');
        const yesterday = dayjs().subtract(1, 'day').format('YYYY-MM-DDTHH:mm:ss');
        // console.log(date, yesterday);
        const firstDayOfMonth = dayjs().date(1).format('YYYY-MM-DDTHH:mm:ss');
        // console.log(firstDayOfMonth);
        // console.log(firstDayOfMonth);
        this.props.getProductCategoriesDropdown();
        // this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
        //     `HightideReportsBeginDate`);
        // this.props.formInput(date, `HightideReportsEndDate`);

        this.props.formInput(firstDayOfMonth, `HightideReportsDetailedProductSalesBeginDate`);
        this.props.formInput(date, `HightideReportsDetailedProductSalesEndDate`);
        this.props.formInput(yesterday, `HightideReportsWeeklySalesEndDate`);
        this.props.formInput(firstDayOfMonth, `HightideReportsEliteSalesBeginDate`);
        this.props.formInput(date, `HightideReportsEliteSalesEndDate`);
        this.props.formInput(firstDayOfMonth, `HightideReportsEliteSalesPersonRankBeginDate`);
        this.props.formInput(date, `HightideReportsEliteSalesPersonRankEndDate`);
        this.props.formInput(firstDayOfMonth, `HightideReportsGlobalOnSaleBeginDate`);
        this.props.formInput(date, `HightideReportsGlobalOnSaleEndDate`);
        this.props.formInput(firstDayOfMonth, `HightideReportsSageExportBeginDate`);
        this.props.formInput(date, `HightideReportsSageExportEndDate`);
        this.props.formInput(firstDayOfMonth, `HightideReportsPaymentReportLogBeginDate`);
        this.props.formInput(date, `HightideReportsPaymentReportLogEndDate`);
        this.props.formInput(firstDayOfMonth, `HightideReportsSalesLogBeginDate`);
        this.props.formInput(date, `HightideReportsSalesLogEndDate`);
        this.props.formInput(firstDayOfMonth, `HightideReportsRevenueSnapshotBeginDate`);
        this.props.formInput(date, `HightideReportsRevenueSnapshotEndDate`);
        this.props.formInput(firstDayOfMonth, `HightideReportsOperationsReportBeginDate`);
        this.props.formInput(date, `HightideReportsOperationsReportSalesEndDate`);
        this.props.formInput(firstDayOfMonth, `HightideReportsSafeBalancesBeginDate`);
        this.props.formInput(date, `HightideReportsSafeBalancesEndDate`);
        this.props.formInput(date, `HightideReportsInventoryAtDateEndDate`)
        // if (localStorage.getItem("HightideReportsBranchIds") != null) {
        //     this.props.formInput(localStorage.getItem("HightideReportsBranchIds").split(","), "HightideReportsBranchIds")
        // } 

    }

    componentDidUpdate(prevProps) {
        // if (this.props.selectedBranchIds != undefined && this.props.selectedBranchIds != prevProps.selectedBranchIds) {
        //     localStorage.setItem("HightideReportsBranchIds", this.props.selectedBranchIds)
        // }

        if (this.props.sageExportGuid != undefined && this.props.sageExportGuid != prevProps.sageExportGuid) {
            this.props.getCsvReport(`reports/excel/checkReportGenerationStatus?executionNumber=${this.props.sageExportGuid}`, "SageX3Export", "getWithStatus");
            this.timer = setInterval(() => {
                this.props.getCsvReport(`reports/excel/checkReportGenerationStatus?executionNumber=${this.props.sageExportGuid}`, "SageX3Export", "getWithStatus");
            }, 10000);
        }

        if (this.props.inventoryAtDateGuid != undefined && this.props.inventoryAtDateGuid != prevProps.inventoryAtDateGuid) {
            this.props.getCsvReport(`reports/excel/checkReportGenerationStatus?executionNumber=${this.props.inventoryAtDateGuid}`, "InventoryValuation", "getWithStatus");
            this.timer = setInterval(() => {
                this.props.getCsvReport(`reports/excel/checkReportGenerationStatus?executionNumber=${this.props.inventoryAtDateGuid}`, "InventoryValuation", "getWithStatus");
            }, 10000);
        }

        if (this.props.reportLoadCompleteTimeStamp != undefined && this.props.reportLoadCompleteTimeStamp != prevProps.reportLoadCompleteTimeStamp) {
            clearInterval(this.timer)
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer)
    }

    componentWillReceiveProps = (newProps) => {
    }

    cleanSearch = () => {
        // this.props.clearFormInput(`HightideReportsBeginDate`);
        // this.props.clearFormInput(`HightideReportsEndDate`);
        this.props.clearFormInput(`HightideReportsDetailedProductSalesBeginDate`);
        this.props.clearFormInput(`HightideReportsDetailedProductSalesEndDate`);
        this.props.clearFormInput(`HightideReportsWeeklySalesEndDate`);
        this.props.clearFormInput(`HightideReportsEliteSalesBeginDate`);
        this.props.clearFormInput(`HightideReportsEliteSalesEndDate`);
        this.props.clearFormInput(`HightideReportsEliteSalesPersonRankBeginDate`);
        this.props.clearFormInput(`HightideReportsEliteSalesPersonRankEndDate`);
        this.props.clearFormInput(`HightideReportsGlobalOnSaleBeginDate`);
        this.props.clearFormInput(`HightideReportsGlobalOnSaleEndDate`);
        this.props.clearFormInput(`HightideReportsSageExportBeginDate`);
        this.props.clearFormInput(`HightideReportsSageExportEndDate`);
        this.props.clearFormInput(`HightideReportsPaymentReportLogBeginDate`);
        this.props.clearFormInput(`HightideReportsPaymentReportLogEndDate`);
        this.props.clearFormInput(`HightideReportsSalesLogBeginDate`);
        this.props.clearFormInput(`HightideReportsSalesLogEndDate`);
        this.props.clearFormInput(`HightideReportsRevenueSnapshotBeginDate`);
        this.props.clearFormInput(`HightideReportsRevenueSnapshotEndDate`);
        this.props.clearFormInput(`HightideReportsOperationsReportBeginDate`);
        this.props.clearFormInput(`HightideReportsOperationsReportSalesEndDate`);
        this.props.clearFormInput(`HightideReportsSafeBalancesBeginDate`);
        this.props.clearFormInput(`HightideReportsSafeBalancesEndDate`);
        this.props.clearFormInput(`HightideReportsInventoryAtDateEndDate`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    downloadReport = (reportName) => {
        // let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        // let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');

        let detailedProductSalesBeginDate = this.props.detailedProductSalesBeginDate ? moment(this.props.detailedProductSalesBeginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let detailedProductSalesEndDate = this.props.detailedProductSalesEndDate ? moment(this.props.detailedProductSalesEndDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let detailedProductSalesBranches = this.props.detailedProductSalesBranches ? this.props.detailedProductSalesBranches.toString() : "ALL";
        let detailedProductSalesCategory = this.props.detailedProductSalesCategory ? this.props.detailedProductSalesCategory : 0;
        let weeklySalesEndDate = this.props.weeklySalesEndDate ? moment(this.props.weeklySalesEndDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let weeklySalesBranches = this.props.weeklySalesBranches ? this.props.weeklySalesBranches.toString() : "ALL";
        let weeklySalesCategory = this.props.weeklySalesCategory ? this.props.weeklySalesCategory : 0;
        let eliteSalesBeginDate = this.props.eliteSalesBeginDate ? moment(this.props.eliteSalesBeginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let eliteSalesEndDate = this.props.eliteSalesEndDate ? moment(this.props.eliteSalesEndDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let eliteSalesPersonRankBeginDate = this.props.eliteSalesPersonRankBeginDate ? moment(this.props.eliteSalesPersonRankBeginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let eliteSalesPersonRankEndDate = this.props.eliteSalesPersonRankEndDate ? moment(this.props.eliteSalesPersonRankEndDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let globalOnSaleBeginDate = this.props.globalOnSaleBeginDate ? moment(this.props.globalOnSaleBeginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let globalOnSaleEndDate = this.props.globalOnSaleEndDate ? moment(this.props.globalOnSaleEndDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let globalOnSaleBranches = this.props.globalOnSaleBranches ? this.props.globalOnSaleBranches.toString() : "ALL";
        let sageExportBeginDate = this.props.sageExportBeginDate ? moment(this.props.sageExportBeginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let sageExportEndDate = this.props.sageExportEndDate ? moment(this.props.sageExportEndDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let sageExportReportType = this.props.sageExportReportType ? this.props.sageExportReportType : "All";
        let paymentReportLogBeginDate = this.props.paymentReportLogBeginDate ? moment(this.props.paymentReportLogBeginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let paymentReportLogEndDate = this.props.paymentReportLogEndDate ? moment(this.props.paymentReportLogEndDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let paymentReportLogBranches = this.props.paymentReportLogBranches ? this.props.paymentReportLogBranches.toString() : "ALL";
        let salesLogBeginDate = this.props.salesLogBeginDate ? moment(this.props.salesLogBeginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let salesLogEndDate = this.props.salesLogEndDate ? moment(this.props.salesLogEndDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let salesLogBranches = this.props.salesLogBranches ? this.props.salesLogBranches.toString() : "ALL";
        let salesLogIsSelectAll = this.props.branchOptions && this.props.salesLogBranches ? this.props.branchOptions.length == this.props.salesLogBranches.length : false;
        let revenueSnapshotBeginDate = this.props.revenueSnapshotBeginDate ? moment(this.props.revenueSnapshotBeginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let revenueSnapshotEndDate = this.props.revenueSnapshotEndDate ? moment(this.props.revenueSnapshotEndDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let operationsReportBeginDate = this.props.operationsReportBeginDate ? moment(this.props.operationsReportBeginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let operationsReportSalesEndDate = this.props.operationsReportSalesEndDate ? moment(this.props.operationsReportSalesEndDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let safeBalancesBeginDate = this.props.safeBalancesBeginDate ? moment(this.props.safeBalancesBeginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let safeBalancesEndDate = this.props.safeBalancesEndDate ? moment(this.props.safeBalancesEndDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let inventoryAtDateEndDate = this.props.inventoryAtDateEndDate ? moment(this.props.inventoryAtDateEndDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let inventoryAtDateBranches = this.props.inventoryAtDateBranches ? this.props.inventoryAtDateBranches.toString() : "ALL";
        let branchIds = "All" //this.props.selectedBranchIds.join(",");
        let detailedProductSalesOption = this.props.detailedProductSalesOption;
        let paymentReportLogBranchId = this.props.paymentReportLogBranchOption;

        switch (reportName) {
            case "DetailedProductSales":
                if (checkDateRange(detailedProductSalesBeginDate, detailedProductSalesEndDate)) {
                    this.props.showError(LOOKUP.report.common.dateRangeError);
                } else {
                    this.props.getCsvReport(`reports/excel/hightideDetailedProductSales?beginDate=${detailedProductSalesBeginDate}&endDate=${detailedProductSalesEndDate}&branchIds=${detailedProductSalesBranches}&categoryId=${detailedProductSalesCategory}&includeDepositRounding=${detailedProductSalesOption}`, "DetailedProductSales");
                }
                break;
            case "WeeklySalesOrderingMultistore":
                this.props.getCsvReport(`reports/excel/hightideWeeklySalesOrderingMultistore?endDate=${weeklySalesEndDate}&branchIds=${weeklySalesBranches}&categoryId=${weeklySalesCategory}`, "WeeklySalesOrderingMultistore");
                break;
            case "EliteSales":
                if (checkDateRange(eliteSalesBeginDate, eliteSalesEndDate)) {
                    this.props.showError(LOOKUP.report.common.dateRangeError);
                } else {
                    this.props.getCsvReport(`reports/excel/hightideEliteSales?beginDate=${eliteSalesBeginDate}&endDate=${eliteSalesEndDate}&branchIds=${branchIds}`, "EliteSales");
                }
                break;
            case "EliteSalesPersonRank":
                if (checkDateRange(eliteSalesPersonRankBeginDate, eliteSalesPersonRankEndDate)) {
                    this.props.showError(LOOKUP.report.common.dateRangeError);
                } else {
                    this.props.getCsvReport(`reports/excel/hightideEliteSalesPersonRank?beginDate=${eliteSalesPersonRankBeginDate}&endDate=${eliteSalesPersonRankEndDate}&branchIds=${branchIds}`, "EliteSalesPersonRank");
                }
                break;
            case "GlobalOnSale":
                if (checkDateRange(globalOnSaleBeginDate, globalOnSaleEndDate)) {
                    this.props.showError(LOOKUP.report.common.dateRangeError);
                } else {
                    this.props.getCsvReport(`reports/excel/hightideGlobalOnSale?beginDate=${globalOnSaleBeginDate}&endDate=${globalOnSaleEndDate}&branchIds=${globalOnSaleBranches}`, "GlobalOnSale");
                }
                break;
            case "SageX3Export":
                if (checkDateRange(sageExportBeginDate, sageExportEndDate)) {
                    this.props.showError(LOOKUP.report.common.dateRangeError);
                } else {
                    let model = {
                        beginDate: sageExportBeginDate,
                        endDate: sageExportEndDate,
                        branchIds: branchIds,
                        reportType: sageExportReportType
                    }
                    this.props.getSageExportGuid(model);
                }
                break;
            case "FinanceLocationList":
                this.props.getCsvReport(`reports/excel/hightideFinanceLocationList?branchIds=${branchIds}`, "LocationList");
                break;
            case "FinancePaymentReportLog":
                if (checkDateRange(paymentReportLogBeginDate, paymentReportLogEndDate)) {
                    this.props.showError(LOOKUP.report.common.dateRangeError);
                } else {
                    this.props.getCsvReport(`reports/excel/hightideFinancePaymentReportLog?beginDate=${paymentReportLogBeginDate}&endDate=${paymentReportLogEndDate}&branchIds=${paymentReportLogBranches}`, "PaymentReportLog");
                }
                break;
            case "FinanceSalesLog":
                if (checkDateRange(salesLogBeginDate, salesLogEndDate)) {
                    this.props.showError(LOOKUP.report.common.dateRangeError);
                } else {
                    this.props.getCsvReport(`reports/excel/hightideFinanceSalesLog?beginDate=${salesLogBeginDate}&endDate=${salesLogEndDate}&branchIds=${salesLogBranches}&isSelectAll=${salesLogIsSelectAll}`, "SalesLog");
                }
                break;
            case "FinanceRevenueSnapshot":
                if (checkDateRange(revenueSnapshotBeginDate, revenueSnapshotEndDate)) {
                    this.props.showError(LOOKUP.report.common.dateRangeError);
                } else {
                    this.props.getCsvReport(`reports/excel/hightideFinanceRevenueSnapshot?beginDate=${revenueSnapshotBeginDate}&endDate=${revenueSnapshotEndDate}&branchIds=${175}`, "RevenueSnapshot");
                }
                break;
            case "FinanceOperationsReport":
                if (checkDateRange(operationsReportBeginDate, operationsReportSalesEndDate)) {
                    this.props.showError(LOOKUP.report.common.dateRangeError);
                } else {
                    this.props.getCsvReport(`reports/excel/hightideFinanceOperationsReport?beginDate=${operationsReportBeginDate}&endDate=${operationsReportSalesEndDate}&branchIds=${branchIds}`, "OperationsReport");
                }
                break;
            case "FinanceSafeBalances":
                if (checkDateRange(safeBalancesBeginDate, safeBalancesEndDate)) {
                    this.props.showError(LOOKUP.report.common.dateRangeError);
                } else {
                    this.props.getCsvReport(`reports/excel/hightideFinanceSafeBalances?beginDate=${safeBalancesBeginDate}&endDate=${safeBalancesEndDate}&branchIds=${branchIds}`, "SafeBalances");
                }
                break;
            case "InventoryAtDate":
                {
                    let model = {
                        endDate: inventoryAtDateEndDate,
                        branchIds: inventoryAtDateBranches
                    }
                    this.props.getInventoryAtDateGuid(model);
                }
                break;
        }

        // }
    }



    redirectToReport = () => {
        this.props.navigate("/report");
        //test
    }


    render() {
        return (
            <Grid headerContent={reportHightideReportsCrumb}>
                <PageHeader title={LOOKUP.report.HightideReports.text} description={LOOKUP.report.HightideReports.description} />
                <CardSimple>
                    <Body
                        download={this.downloadReport}
                        branchOptions={this.props.branchOptions}
                        loggedBranch={this.props.loggedBranch}
                        categoryOptions={this.props.categoryOptions}
                        provinceOptions={this.props.provinceOptions}
                        isHighTide={this.props.isHighTide}
                    />
                </CardSimple>
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name.replace("Canna Cabana - ", ""), value: item.id.toString(), provinceState: item.provinceState
        });
    })

    const cat = state.entity.productCategories || [];
    let categories = [];
    cat.map(item => {
        categories.push({
            text: item.name,
            value: item.id.toString(),
            isCannabis: item.isCannabis
        });
    });

    categories.sort((a, b) => {
        if (a.text < b.text)
            return -1;
        if (a.text > b.text)
            return 1;
        return 0;
    });

    categories.unshift({ text: "All", value: "0" });

    let provinceOptions = [
        { text: "All", value: "All" },
        { text: "BC", value: "BC" },
        { text: "AB", value: "AB" },
        { text: "MB", value: "MB" },
        { text: "SK", value: "SK" },
        { text: "ON", value: "ON" }
    ]

    return {
        branchOptions: branchOptions,
        categoryOptions: categories,
        provinceOptions: provinceOptions,
        loggedBranch: state.common.branchId,
        detailedProductSalesBeginDate: state.form.HightideReportsDetailedProductSalesBeginDate,
        detailedProductSalesEndDate: state.form.HightideReportsDetailedProductSalesEndDate,
        detailedProductSalesProvince: state.form.HightideReportsDetailedProductSalesProvince,
        detailedProductSalesBranches: state.form.HightideReportsDetailedProductSalesBranches,
        detailedProductSalesCategory: state.form.HightideReportsDetailedProductSalesCategory,
        detailedProductSalesOption: state.form.HightideReportsDetailedProductSalesOption,
        weeklySalesEndDate: state.form.HightideReportsWeeklySalesEndDate,
        weeklySalesProvince: state.form.HightideReportsWeeklySalesProvince,
        weeklySalesBranches: state.form.HightideReportsWeeklySalesBranches,
        weeklySalesCategory: state.form.HightideReportsWeeklySalesCategory,
        eliteSalesBeginDate: state.form.HightideReportsEliteSalesBeginDate,
        eliteSalesEndDate: state.form.HightideReportsEliteSalesEndDate,
        eliteSalesPersonRankBeginDate: state.form.HightideReportsEliteSalesPersonRankBeginDate,
        eliteSalesPersonRankEndDate: state.form.HightideReportsEliteSalesPersonRankEndDate,
        globalOnSaleBeginDate: state.form.HightideReportsGlobalOnSaleBeginDate,
        globalOnSaleEndDate: state.form.HightideReportsGlobalOnSaleEndDate,
        globalOnSaleProvince: state.form.HightideReportsGlobalOnSaleProvince,
        globalOnSaleBranches: state.form.HightideReportsGlobalOnSaleBranches,
        sageExportBeginDate: state.form.HightideReportsSageExportBeginDate,
        sageExportEndDate: state.form.HightideReportsSageExportEndDate,
        sageExportReportType: state.form.HightideReportsSageExportReportType,
        paymentReportLogBeginDate: state.form.HightideReportsPaymentReportLogBeginDate,
        paymentReportLogEndDate: state.form.HightideReportsPaymentReportLogEndDate,
        paymentReportLogBranches: state.form.HightideReportsPaymentReportLogBranches,
        salesLogBeginDate: state.form.HightideReportsSalesLogBeginDate,
        salesLogEndDate: state.form.HightideReportsSalesLogEndDate,
        salesLogBranches: state.form.HightideReportsSalesLogBranches,
        revenueSnapshotBeginDate: state.form.HightideReportsRevenueSnapshotBeginDate,
        revenueSnapshotEndDate: state.form.HightideReportsRevenueSnapshotEndDate,
        operationsReportBeginDate: state.form.HightideReportsOperationsReportBeginDate,
        operationsReportSalesEndDate: state.form.HightideReportsOperationsReportSalesEndDate,
        safeBalancesBeginDate: state.form.HightideReportsSafeBalancesBeginDate,
        safeBalancesEndDate: state.form.HightideReportsSafeBalancesEndDate,
        inventoryAtDateEndDate: state.form.HightideReportsInventoryAtDateEndDate,
        inventoryAtDateBranches: state.form.HightideReportsInventoryAtDateBranches,
        sageExportGuid: state.reports.sageExportGuid,
        inventoryAtDateGuid: state.reports.inventoryAtDateGuid,
        reportLoadCompleteTimeStamp: state.reports.reportLoadCompleteTimeStamp,
        isHighTide: state.common.applicationSettings.isHighTide
    };
};

const mapDispatchToProps = dispatch => {
    return {
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        showLoading: () => dispatch(showLoadingSpinner()),
        hideLoading: () => dispatch(hideLoadingSpinner()),
        getCsvReport: (url, name, mode) => dispatch(getCsvReport(url, name, mode)),
        getSageExportGuid: (model) => dispatch(getSageExportGuid(model)),
        getInventoryAtDateGuid: (model) => dispatch(getInventoryAtDateGuid(model)),
        // getProductTypes: () => dispatch(getProductTypes())
        getProductCategoriesDropdown: () => dispatch(getProductCategoriesDropdown())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HightideReports);